import { forwardRef } from "react";
import styled from "styled-components";
import Text from "../text";
import { ArrowUpOutlined, ArrowDownOutlined } from "../../icons";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDelta = styled(Text).withConfig({
  displayName: "delta__StyledDelta",
  componentId: "sc-hv8f1l-0"
})(["white-space:nowrap;"]);
export const Delta = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    value,
    precision = 0,
    suffix,
    invertColor = false,
    ...rest
  } = _ref;
  const prefix = getPrefixIcon(value);
  const color = getColor(value, invertColor);
  const fixedValue = Math.abs(value).toFixed(precision);
  return /*#__PURE__*/_jsxs(StyledDelta, {
    ref: ref,
    fontFamily: "secondary",
    ...rest,
    color: color,
    children: [prefix, fixedValue, suffix]
  });
});
function getColor(value, invert) {
  if (value > 0) {
    return invert ? "negative.base" : "positive.base";
  }
  if (value < 0) {
    return invert ? "positive.base" : "negative.base";
  }
  return "warning.base";
}
function getPrefixIcon(value) {
  if (value > 0) {
    return /*#__PURE__*/_jsx(ArrowUpOutlined, {});
  }
  if (value < 0) {
    return /*#__PURE__*/_jsx(ArrowDownOutlined, {});
  }
  return null;
}
export default Delta;